import { Box, CircularProgress, Modal, TextField, Typography } from "@mui/material"
import DateRangeIcon from "@mui/icons-material/DateRange"
import React, { useEffect, useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import useStyles from "./useStyles"


import { updateApplicationInstanceAppModule } from "../../../../app/services/eAuthz/updateApplicationInstanceAppModuleEAuthz"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar,
} from "../../../../redux/actions/app"
import { useDispatch } from "react-redux"
import { logEvent } from "../../../../utils/LogEvents"
import { EnableApplicationInstanceAppModule } from "../../../../app/services/eAuthz/EnableApplicationInstanceAppModule"
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  height: 320,
  bgcolor: "white",
  p: 3,
  borderRadius: "8px",
  boxShadow: "0px 0px 4px rgba(36, 55, 143, 0.4)",
}

export const EditModule = ({ module, isNewModule, refresh, applicationInstanceId, startDate, finishDate }) => {
  const classes = useStyles()
  const [openModal, setopenModal] = useState(false)
  const [showCircularProgress, setshowCircularProgress] = useState(false)
  const [errorDateStart, seterrorDateStart] = useState(false)
  const [errorDateFinish, seterrorDateFinish] = useState(false)
  const [errorTextFinishDate, setErrorTextFinishDate] = useState("")

  const handleOpen = () => {
    setopenModal(true)
  }
  // const formatDate = (date) => {
  //   let formattedDate

  //   if (date) {
  //     const newDate = new Date(date)
  //     formattedDate = {
  //       day: newDate.getUTCDate(),
  //       mounth: newDate.getUTCMonth(),
  //       year: newDate.getUTCFullYear(),
  //     }
  //   }

  //   return formattedDate
  // }

  const [selectedDateStart, setSelectedDateStart] = useState(
    startDate ? startDate.split("T")[0] 
    : new Date().toISOString().split("T")[0] 
  )
  const [selectedDateFinish, setSelectedDateFinish] = useState(
    finishDate ? finishDate.split("T")[0] 
    : null
  )

  const handleDateStartChange = (date) => {

    setSelectedDateStart(date)
    seterrorDateFinish(false)
    seterrorDateStart(false)
  }
  const handleDateFinishChange = (date) => {
    setSelectedDateFinish(date)
    seterrorDateFinish(false)
    seterrorDateStart(false)
  }
  const dispatch = useDispatch()

  const addModule = async () => {
    setshowCircularProgress(true)
    try {
      if (!selectedDateStart) {
        seterrorDateStart(true)
        return
      }
      const currentDate = new Date()
      if (selectedDateFinish && selectedDateFinish < selectedDateStart) {
        seterrorDateFinish(true)
        setErrorTextFinishDate(
          "La fecha de finalización debe ser posterior a la fecha de inicio",
        )

        return
      }
      if (selectedDateFinish && selectedDateFinish < currentDate) {
        seterrorDateFinish(true)
        setErrorTextFinishDate("La fecha de finalización debe ser posterior a hoy")
        return
      }

      const body = {
        applicationInstanceId,
        appModuleCode: module.appModule,
        startDate: selectedDateStart && new Date(selectedDateStart).toISOString(),
        finishDate: selectedDateFinish
          ? new Date(selectedDateFinish).toISOString()
          : null,
        subscriptionTypeRefCode: null,
      }
      if (isNewModule) {
        const response = await EnableApplicationInstanceAppModule(body)
        logEvent("CGI - EnableApplicationInstanceAppModule", {
          body: {
            body,
          },
          response: response,
        })
      } else {
        const response = await updateApplicationInstanceAppModule(body)
        logEvent("CGI - updateApplicationInstanceAppModule", {
          body: body,
          response: response,
        })
      }

      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar("Actualización exitosa"))
      await refresh()
    } catch (error) {
      console.log(error)
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar("Ocurrió un error en un servicio de: eAuthzAPI"),
      )
    } finally {
      setshowCircularProgress(false)
    }
  }
  return (
    <>
      <button className={classes.buttonEditModule} onClick={handleOpen}>
        <Typography className={classes.typographyButton}>
          {isNewModule ? "Habilitar" : "Editar"}
        </Typography>
      </button>
      <Modal open={openModal} onClose={() => setopenModal(false)}>
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <CloseIcon
              sx={{
                fontSize: "medium",
                color: "#263057",
                cursor: "pointer",
              }}
              onClick={() => setopenModal(false)}
            />
          </div>

          <div style={{ display: "flex" }}>
            <Typography sx={{ color: "#263057", fontSize: "1.3em" }}>
              {isNewModule ? `Habilitar ${module.appModuleName}` : `Editar periodo de habilitación del ${module.appModuleName}`}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "5%",
              marginTop: 20,
            }}
          >
            <div style={{ width: '20%', display: "flex", justifyContent: "center", alignItems: "center" }}><DateRangeIcon sx={{ color: "#263057", fontSize: "3em" }} /></div>

            <div style={{ width: "80%" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ color: "#263057", width: "20%" }}>
                  Desde:
                </Typography>

                <div
                  style={{
                    width: "70%",
                  }}
                >
                  <TextField
                    fullWidth
                    label="Fecha de inicio"
                    type="date"
                    value={selectedDateStart}
                    onChange={(event) => handleDateStartChange(event.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    error={errorDateStart}
                    helperText={errorDateStart ? "Seleccione una fecha de inicio" : ""}
                  />
                </div>
              </div>
              <div style={{ display: "flex", marginTop: 16 }}>
                <Typography sx={{ color: "#263057", width: "20%" }}>
                  Hasta:
                </Typography>
                <div
                  style={{
                    width: "70%",
                  }}
                >
                  <TextField
                    fullWidth
                    label="Fecha de expiración"
                    type="date"
                    value={selectedDateFinish}
                    onChange={(event) => handleDateFinishChange(event.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    error={errorDateFinish}
                    helperText={errorDateFinish ? errorTextFinishDate : ""}
                  />
                </div>
              </div>
            </div>
          </div>

          <Box className={classes.buttons} style={{ marginLeft: "45%" }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              addModule={addModule}
            />

            <ButtonClose handleClose={() => setopenModal(false)} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm({ showCircularProgress, addModule }) {
  const classes = useStyles()
  const [isProgressComplete, setProgressComplete] = useState(false)

  const handleButtonClick = async () => {
    if (!isProgressComplete) {
      try {
        await addModule()
        setProgressComplete(true)
      } catch (error) {
        setProgressComplete(false)
      }
    }
  }

  useEffect(() => {
    if (isProgressComplete) {
      const timeout = setTimeout(() => {
        setProgressComplete(false)
      }, 1000)
      return () => clearTimeout(timeout)
    }
  }, [isProgressComplete])

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <button
        className={`${classes.confirmButton} ${isProgressComplete ? classes.disabledButton : ""
          }`}
        disabled={isProgressComplete || showCircularProgress}
        onClick={handleButtonClick}
      >
        {showCircularProgress ? (
          <CircularProgress size="1.5rem" color="inherit" />
        ) : (
          <Typography className={classes.confirmButtonTypography}>
            Editar
          </Typography>
        )}
      </button>
    </div>
  )
}

function ButtonClose({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
